// pre
import InsuranceType from "./components/InsuranceType.vue"

// auto
import VehicleYear from "./components/auto/VehicleYear.vue"
import VehicleMake from "./components/auto/VehicleMake.vue"
import VehicleModel from "./components/auto/VehicleModel.vue"

import VehicleTrimAndVehicleOwnershipType from "./components/auto/VehicleTrimAndVehicleOwnershipType.vue"

import VehiclePrimaryUseTypeAnnualMileageDaysDrivenPerWeekRequestedAutoCoverageType from "./components/auto/VehiclePrimaryUseTypeAnnualMileageDaysDrivenPerWeekRequestedAutoCoverageType.vue"

import AddAnotherVehicle from "./components/auto/AddAnotherVehicle.vue"
import AutoInsuranceLength from "./components/auto/AutoInsuranceLength.vue"
import CurrentAutoInsurer from "./components/auto/CurrentAutoInsurer.vue"
import CurrentAutoInsurerLength from "./components/auto/CurrentAutoInsurerLength.vue"
import NumberOfDrivers from "./components/auto/NumberOfDrivers.vue"

import GenderIsMarriedCreditRating from "./components/GenderIsMarriedCreditRating.vue"

import AccidentsInPast3Years from "./components/auto/AccidentsInPast3Years.vue"
import TicketsInPast3Years from "./components/auto/TicketsInPast3Years.vue"
import DuiNeedsSr22 from "./components/auto/DuiNeedsSr22.vue"
import LicenseStatus from "./components/auto/LicenseStatus.vue"

import CurrentResidenceTypeIsInterestedInHomeInsuranceQuotes from "./components/CurrentResidenceTypeIsInterestedInHomeInsuranceQuotes.vue"

import DateOfBirthNameAddressCityZipCodeEmailPhoneNumber from "./components/DateOfBirthNameAddressCityZipCodeEmailPhoneNumber.vue"

// home
import HomeType from "./components/home/HomeType.vue"
import AddressCityStateZipCode from "./components/AddressCityStateZipCode.vue"
import OwnHome from "./components/home/OwnHome.vue"
import YearHomeBought from "./components/home/YearHomeBought.vue"

import PrimaryResidence from "./components/home/PrimaryResidence.vue"
import HomeSecuritySystem from "./components/home/HomeSecuritySystem.vue"
import HomeClaimsInPast5Years from "./components/home/HomeClaimsInPast5Years.vue"
import CurrentHomeInsurer from "./components/home/CurrentHomeInsurer.vue"
import CurrentHomeDeductibleAndLiability from "./components/home/CurrentHomeDeductibleAndLiability.vue"

import Name from "./components/Name.vue"
import DateOfBirth from "./components/DateOfBirth.vue"
import Email from "./components/Email.vue"
import PhoneNumber from "./components/PhoneNumber.vue"

// other
import Message from "./components/Message.vue"

const steps = {
    Pre: [
        InsuranceType.name
    ],
    Post: [
        Message.name
    ],
    Auto: [
        VehicleYear.name,
        VehicleMake.name,
        VehicleModel.name,

        VehicleTrimAndVehicleOwnershipType.name,

        VehiclePrimaryUseTypeAnnualMileageDaysDrivenPerWeekRequestedAutoCoverageType.name,

        AddAnotherVehicle.name,
        AutoInsuranceLength.name,
        CurrentAutoInsurer.name,
        CurrentAutoInsurerLength.name,
        NumberOfDrivers.name,

        GenderIsMarriedCreditRating.name,

        AccidentsInPast3Years.name,
        TicketsInPast3Years.name,
        DuiNeedsSr22.name,
        LicenseStatus.name,

        CurrentResidenceTypeIsInterestedInHomeInsuranceQuotes.name,

        DateOfBirthNameAddressCityZipCodeEmailPhoneNumber.name
    ],
    Home: [
        HomeType.name,
        AddressCityStateZipCode.name,
        OwnHome.name,
        YearHomeBought.name,

        // query home info

        // steps if we get home info
        PrimaryResidence.name,
        HomeSecuritySystem.name,
        HomeClaimsInPast5Years.name,
        CurrentHomeInsurer.name,
        CurrentHomeDeductibleAndLiability.name,

        // steps if we get home info or don't get home info
        Name.name,
        DateOfBirth.name,
        Email.name,
        PhoneNumber.name
    ]
};

const stepValues = {
    // pre
    InsuranceType: InsuranceType.name,

    // post
    Message: Message.name,

    // auto
    VehicleYear: VehicleYear.name,
    VehicleMake: VehicleMake.name,
    VehicleModel: VehicleModel.name,

    VehicleTrimAndVehicleOwnershipType: VehicleTrimAndVehicleOwnershipType.name,

    VehiclePrimaryUseTypeAnnualMileageDaysDrivenPerWeekRequestedAutoCoverageType: VehiclePrimaryUseTypeAnnualMileageDaysDrivenPerWeekRequestedAutoCoverageType.name,

    AddAnotherVehicle: AddAnotherVehicle.name,
    AutoInsuranceLength: AutoInsuranceLength.name,
    CurrentAutoInsurer: CurrentAutoInsurer.name,
    CurrentAutoInsurerLength: CurrentAutoInsurerLength.name,
    NumberOfDrivers: NumberOfDrivers.name,

    GenderIsMarriedCreditRating: GenderIsMarriedCreditRating.name,

    AccidentsInPast3Years: AccidentsInPast3Years.name,
    TicketsInPast3Years: TicketsInPast3Years.name,
    DuiNeedsSr22: DuiNeedsSr22.name,
    LicenseStatus: LicenseStatus.name,

    CurrentResidenceTypeIsInterestedInHomeInsuranceQuotes: CurrentResidenceTypeIsInterestedInHomeInsuranceQuotes.name,

    DateOfBirthNameAddressCityZipCodeEmailPhoneNumber: DateOfBirthNameAddressCityZipCodeEmailPhoneNumber.name,

    // home
    HomeType: HomeType.name,
    AddressCityStateZipCode: AddressCityStateZipCode.name,
    OwnHome: OwnHome.name,
    YearHomeBought: YearHomeBought.name,

    PrimaryResidence: PrimaryResidence.name,
    HomeSecuritySystem: HomeSecuritySystem.name,
    HomeClaimsInPast5Years: HomeClaimsInPast5Years.name,
    CurrentHomeInsurer: CurrentHomeInsurer.name,
    CurrentHomeDeductibleAndLiability: CurrentHomeDeductibleAndLiability.name,

    Name: Name.name,
    DateOfBirth: DateOfBirth.name,
    Email: Email.name,
    PhoneNumber: PhoneNumber.name
};

export { steps, stepValues }
